import { HTTP } from '../../http';
import router from '../../router/index';
import { i18n } from '../../translations/index';

const state = {
  authenticated: false,
  confirmation: false,
  loginError: false,
  registerData: null,
  registerDataErrors: null,
  registerStatus: null,
  user: JSON.parse(localStorage.getItem('exideUser')) || null
};

const mutations = {
  SET_USER(state, data) {
    state.user = data;
  },
  SET_REGISTER_DATA(state, data) {
    state.registerData = data;
  },
  SET_REGISTER_DATA_ERRORS(state, data) {
    state.registerDataErrors = data;
  },
  SET_REGISTER_STATUS(state, data) {
    state.registerStatus = data;
  }
};

const getters = {
  getUser: state => state.user,
  getLoginError: state => state.loginError,
  getRegisterData: state => state.registerData,
  getRegisterDataErrors: state => state.registerDataErrors,
  getRegisterStatus: state => state.registerStatus
};

const actions = {
  async getUser({ commit, state }) {
    const user = await HTTP.get('/api/user');
    const userData = {
      token: state.user.token,
      expires_at: state.user.expires_at,
      authenticated: true,
      isNew: user.data.is_new,
      hasTester: user.data.has_tester,
      firstName: state.user.firstName,
      language: state.user.language,
      country: state.user.country,
      currency: user.data.currency
    };
    localStorage.setItem('exideUser', JSON.stringify(userData));
    commit('SET_USER', userData);
  },
  loginAction: ({ commit, dispatch }, payload) => {
    commit('SET_USER', null);
    HTTP.post('api/auth/login', payload)
      .then(response => {
        const userData = {
          token: response.data.data.accessToken,
          expires_at: response.data.data.expiresAt,
          authenticated: true,
          isNew: response.data.data.isNew,
          hasTester: response.data.data.hasTester,
          firstName: response.data.data.firstName,
          language: response.data.data.language,
          country: response.data.data.country,
          currency: response.data.data.currency
        };
        i18n.locale = response.data.data.language;
        localStorage.setItem('exideUserLanguage', response.data.data.language);
        localStorage.setItem('exideUser', JSON.stringify(userData));
        commit('SET_USER', userData);
      })
      .catch(() => {
        dispatch('setMessage', {
          status: 'danger',
          text: i18n.tc('login.invalidCredentials')
        });
        localStorage.removeItem('exideUser');
        commit('SET_USER', null);
      });
  },
  logoutAction: ({ commit, dispatch }) => {
    localStorage.removeItem('exideUser');

    dispatch('clearCurrentProccess');
    commit('SET_USER', null);
  },
  clearCurrentProccess({ commit }) {
    localStorage.removeItem('exideClient');
    localStorage.removeItem('exideVehicle');
    localStorage.removeItem('exideTestResult');
    localStorage.removeItem('exideBrandList');
    localStorage.removeItem('exideBatteries');
    localStorage.removeItem('exideQuoteBatteries');
    localStorage.removeItem('exideTestedWithTester');
    localStorage.removeItem('capacity');

    commit('setChosenBatteries', []);
    commit('SET_CURRENT_VEHICLE', null);
    commit('SET_CURRENT_BATTERIES', []);
    commit('SET_CURRENT_TEST_RESULT', null);
  },

  setRegisterDataAction: ({ commit }, payload) => {
    HTTP.post('/api/garage/validate-register-data', {
      register: payload
    })
      .then(() => {
        commit('SET_REGISTER_DATA_ERRORS', false);
        commit('SET_REGISTER_DATA', payload);
        router.push({ name: 'Register Set Password' });
      })
      .catch(error => {
        commit('SET_REGISTER_DATA_ERRORS', error.response.data.errors);
      });
  },
  createRegisterPasswordAction: ({ commit }, payload) => {
    const register = state.registerData;
    register.password = payload;
    HTTP.post('/api/garage/register', {
      register: register
    })
      .then(response => {
        commit('SET_REGISTER_STATUS', {
          status: 'success',
          text: i18n.tc('login.nowYouAreAbleToLogin')
        });
      })
      .catch(error => {
        commit('SET_REGISTER_STATUS', { status: 'danger', text: error });
      });
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
